import { useQuery } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useCustomErrors = () =>
  useQuery({
    queryKey: ['customs-errors'],
    queryFn: async () => {
      try {
        const result = await apiClient.customsError.retrieveCustomsErrors.mutation({ body: { criteria: {} } });
        return (result.body as any).data.customsErrors;
      } catch (error) {
        showErrorToast(error, 'Something went wrong');
      }
    },
  });
